import React, { useState } from "react";
import { Col, Flex, Radio, Row, Button, Select, ConfigProvider, DatePicker } from "antd";
import { Text } from "../../Atomics/Text";
import { t } from "i18next";
import i18next from "i18next";
import ptBR from "antd/lib/locale/pt_BR";
import enUS from "antd/lib/locale/en_US";
import { useAuthContext } from "../../../../contexts/AuthContext";
import { Field } from "../../../../styles/global/Pages.styled";

const { RangePicker } = DatePicker;

const periodicity = [
  { label: 'hourly', value: 'HOURLY' },
  { label: 'daily', value: 'DAILY' },
  { label: 'monthly', value: 'MONTHLY' },
  { label: 'raw', value: 'RAW' }
];

export const FiltersAnalysis = ({
  selectedItems,
  //   onShowChartsChange,
  filtersSelected,
  limitCheckboxes,
}) => {
  const { checkToken } = useAuthContext();

  const [filterMetric, setFilterMetric] = useState([]);
  const [filterPeriodicity, setFilterPeriodicity] = useState(null);
  const [isHourlyDisabled, setIsHourlyDisabled] = useState(false);
  const [radiosDatepicker, setRadiosDatepicker] = useState("date");
  const [filterStartDate, setFilterStartDate] = useState(null);
  const [filterEndDate, setFilterEndDate] = useState(null);
  const [dates, setDates] = useState();
  const [daysToDisable, setDaysToDisable] = useState();
  // const [radiosData, setRadiosData] = useState(peridiocity);

  const { Option } = Select;

  // Function to handle date picker change
  const handleDatepickerChange = (value) => {
    try {
      if (value) {
        let startDate = null;
        let endDate = null;
        switch (radiosDatepicker) {
          case "year":
            startDate = value[0]?.startOf("year");
            endDate = value[1]?.endOf("year");
            break;

          case "week":
            startDate = value[0]?.startOf("week");
            endDate = value[1]?.endOf("week");
            break;

          case "month":
            startDate = value[0]?.startOf("month");
            endDate = value[1]?.endOf("month");
            break;

          default:
            startDate = value[0]?.startOf("day");
            endDate = value[1]?.endOf("day");
            break;
        }

        // Set time to midnight (00:00:00) for startDate and endDate
        startDate?.set({ hour: 0, minute: 0, second: 0 });
        endDate?.set({ hour: 0, minute: 0, second: 0 });

        setFilterStartDate(startDate.toISOString().split('.')[0]);
        setFilterEndDate(endDate.toISOString().split('.')[0]);
      } else {
        setFilterStartDate(null);
        setFilterEndDate(null);
      }
    } catch (error) {
      console.error(
        "(Timeline page) Error handling date picker type of picker change:",
        error
      );
      //reportError(error); // Send error report to backend
    }
  };

  // Function to handle date picker change
  const handleDatepicker = (value) => {
    try {
      setRadiosDatepicker(value.target.value);
      if (value.target.value !== radiosDatepicker) {
        setFilterStartDate(null);
        setFilterEndDate(null);
      }
    } catch (error) {
      console.error(
        "(Timeline page) Error handling date picker change:",
        error
      );
      //reportError(error); // Send error report to backend
    }
  };

  // Function to apply filters
  const applyFilters = () => {
    try {
      let data = {
        ids: selectedItems.map((item) => item.id),
        names: selectedItems.map((item) => item.name),
        metric: filterMetric,
        periodicity: filterPeriodicity,
        startDate: filterStartDate,
        endDate: filterEndDate,
      };
      checkToken(); //Validate token
      filtersSelected(data);
      // logger.info('Filters applied!');
    } catch (error) {
      // logger.error('Error applying filters');
      console.error("(Timeline page) Error applying filters:", error);
      //reportError(error) SEND TO BE
    }
  };

  // Effect hook to set radio button data for periodicity

  /**
       * Disable all dates that are not in the range of 62 days
       * @param {Date} current The current date
       * @returns
       */
  const disabled62DaysDate = (current) => {
    if (!dates || (!dates[0] && !dates[1])) {
      return false;
    }

    const tooLate = dates[0] && current.diff(dates[0], 'days') > daysToDisable;
    const tooEarly = dates[1] && dates[1].diff(current, 'days') > daysToDisable;
    return !!tooEarly || !!tooLate;
  };

  return (
    <Row className="analiticFilters" gutter={[32, 32]}>
      {/* Col for filters */}
      <Col span={24}>
        <Flex
          gap="middle"
          align="start"
          justify="space-between"
          horizontal="true"
        >
          <Text $fontColor="coolgray-12>" $fontSize="text_xl" $weight="regular">
            {t("filters")}
          </Text>
        </Flex>
      </Col>

      {/* Creates boxes with the selected items */}
      {!(selectedItems?.length === 0) ?
        <Col span={24}>
          <Row gutter={[32, 32]}>
            {selectedItems?.map((item, index) => {
              return (
                <Col span={6} key={index} id={item?.id}>
                  <Field $backgroundColor="neutral-3" style={{ height: '20px', overflow: 'hidden' }}>
                    <Flex
                      gap="small"
                      justify="space-between"
                      align="center"
                      horizontal="true"
                    >
                      <Flex vertical>
                        <span
                          style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            maxWidth: '100%', // Adjust to container width
                            display: 'block'
                          }}
                        >
                          {item?.name}
                        </span>
                      </Flex>
                    </Flex>
                  </Field>
                </Col>
              );
            })}
          </Row>
        </Col > : null}

      <Col span={24}>
        <Row gutter={[16, 16]}>
          {/* <Col span={6}>
            <Select
              value={filterMetric}
              onChange={handleSelectChange}
              placeholder={t("Select Metric/s")}
              style={{ width: "100%" }}
            >
              {metrics?.map((item, index) => (
                <Option key={index} value={item.value}>
                  {t(item.label)}
                </Option>
              ))}
            </Select>
          </Col> */}

          <Col span={6}>
            <Select
              value={filterPeriodicity} // Use the current periodicity value
              onChange={(value) => {
                // Handle the change
                if (value === "HOURLY" && isHourlyDisabled) {
                  setFilterPeriodicity(null); // Clear if hourly is disabled
                } else if (value === "MONTHLY") {
                  setRadiosDatepicker("month");
                  setFilterPeriodicity(value);
                  setDaysToDisable(730);
                  setDates(null);
                } else if (value === "HOURLY") {
                  setRadiosDatepicker("date");
                  setFilterPeriodicity(value);
                  setDaysToDisable(2);
                  setDates(null);
                } else if (value === "DAILY") {
                  setRadiosDatepicker("date");
                  setFilterPeriodicity(value);
                  setDaysToDisable(30);
                  setDates(null);
                } else if (value === "RAW") {
                  setRadiosDatepicker("date");
                  setFilterPeriodicity(value);
                  setDaysToDisable(1);
                  setDates(null);
                }
                else {
                  setFilterPeriodicity(value); // Set the selected value
                }
              }}
              placeholder={t("Select periodicity")}
              style={{ width: "100%" }}
            >
              {periodicity?.map((item, index) => (
                <Option
                  key={index}
                  value={item.value}
                  disabled={item.value === "HOURLY" && isHourlyDisabled}
                >
                  {t(item.label)}
                </Option>
              ))}
            </Select>
          </Col>

          <Col span={6}>
            <ConfigProvider locale={i18next.resolvedLanguage === "en" ? enUS : ptBR}>
              <RangePicker
                placeholder={[t("startDate"), t("endDate")]}
                disabledDate={disabled62DaysDate}
                onCalendarChange={(val) => setDates(val)}
                value={dates}
                picker={radiosDatepicker}
                onChange={handleDatepickerChange}
                style={{ width: "100%" }}
                showTime={{ format: 'HH:mm' }}
      // format="YYYY-MM-DD HH:mm"
                format={
                  radiosDatepicker === "week"
                    ? i18next.resolvedLanguage === "pt"
                      ? "[Semana] w, YYYY"
                      : "[Week] w, YYYY"
                    : radiosDatepicker === "year"
                      ? "YYYY"
                      : radiosDatepicker === "month"
                        ? "MMM, YYYY"
                        : "YYYY-MM-DD HH:mm"
                }
                renderExtraFooter={() => (
                  <Radio.Group
                    defaultValue={radiosDatepicker}
                    onChange={(picker) => handleDatepicker(picker)}
                  >
                    <Radio key="days" value="days">{t("days")}</Radio>
                    <Radio key="weeks" value="week">{t("weeks")}</Radio>
                    <Radio key="months" value="month">{t("months")}</Radio>
                    <Radio key="years" value="year">{t("years")}</Radio>
                  </Radio.Group>
                )}
              />
            </ConfigProvider>
          </Col>

          <Col span={6} style={{ textAlignLast: 'end' }} offset={6}>
            {/* Button to apply filters */}
            <Button
              disabled={
                selectedItems?.length &&
                  selectedItems?.length > 0 && selectedItems?.length <= limitCheckboxes &&
                  filterStartDate &&
                  filterEndDate &&
                  // filterMetric?.length &&
                  filterPeriodicity != null
                  ? false
                  : true
              }
              shape="round"
              className="ant-btn ant-btn-blue -medium"
              onClick={applyFilters}
            >
              {t("apply")}
            </Button>
          </Col>
        </Row>
      </Col>
    </Row >
  );
};
